module.exports = __webpack_public_path__ + "static/media/og08.601b9335.webp";